import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  // ----------------------------------
  // Modal views
  // ----------------------------------
  modal: {
    margin: 0,
    maxHeight: '100%',

    '& .viboTooltipOvelay': {
      zIndex: 1050,
    },

    '& .rc-dialog-header': {
      display: 'grid',
      alignItems: 'center',
      border: 'none',
      zIndex: 4,
      gridRow: 1,

      '& .rc-dialog-title': {
        ...mixins.longText,
        maxWidth: '90%',
      },
    },

    '& .rc-dialog-body': {
      padding: '0',
      overflowX: 'hidden',
      gridRow: 2,
    },

    '& .rc-dialog-close': {
      opacity: 1,
      padding: 0,
      textShadow: 'none',
      zIndex: 5,
    },
  },

  default: {
    '&, & .rc-dialog-content': {
      borderRadius: '4px',
    },

    '& .rc-dialog-content': {
      backgroundColor: 'var(--background-paper)',
    },

    '& .rc-dialog-header': {
      borderRadius: '4px 4px 0 0',
      color: 'var(--whiteToBalticSeaDark)',
      padding: '0 16px',
      height: '36px',
      backgroundColor: 'var(--primary-main)',

      '& .rc-dialog-title': {
        fontWeight: 400,
        fontSize: '15px',
        lineHeight: '22.5px',

        '@media screen and (min-width: 1441px)': {
          fontSize: '18px',
          lineHeight: '27px',
        },
      },
    },

    '& .rc-dialog-close': {
      color: 'var(--whiteToBalticSeaDark)',
      right: '11px',
      top: '6px',
    },

    '& .rc-dialog-body': {
      '& .modalBody': {
        '&.autoStaticHeight, &.autoHeight': {
          '& > .viboScrollbar': {
            height: 'fit-content!important',
            maxHeight: 'inherit',
            display: 'flex',
            flexDirection: 'column',
          },
        },

        '&.autoStaticHeight': {
          height: 'fit-content!important',
        },

        '&.autoHeight': {
          height: 'auto!important',
          overflow: 'hidden',
        },

        '& > .modalBodyScroll': {
          padding: '20px 10px 20px 20px',
          width: '100%',
        },
      },
    },

    '& .modalFooter': {
      padding: '8px 16px 16px',
      borderRadius: '0 0 4px 4px',
    },

    '& .lottieBox': {
      '&:not(.noGaps).isOverlay': {
        top: '36px',
        height: 'calc(100% - 36px)',
      },
    },

    '&.smModal': {
      width: 'var(--modal-sm-w)',

      '& .modalBody': {
        height: 'var(--modal-sm-h)',

        '&.autoHeight': {
          maxHeight: 'var(--modal-sm-h)',
        },
      },
    },

    '&.mdModal': {
      width: 'var(--modal-sm-w)',

      '& .modalBody': {
        height: 'var(--modal-md-h)',

        '&.autoHeight': {
          maxHeight: 'var(--modal-md-h)',
        },
      },
    },

    '&.lgModal': {
      width: 'var(--modal-lg-w)',

      '& .modalBody': {
        height: 'var(--modal-lg-h)',

        '&.autoHeight': {
          maxHeight: 'var(--modal-lg-h)',
        },
      },
    },

    '&.xlgModal': {
      width: 'var(--modal-lg-w)',

      '& .modalBody': {
        height: 'var(--modal-xlg-h)',

        '&.autoHeight': {
          maxHeight: 'var(--modal-xlg-h)',
        },
      },
    },

    '&.xxlgModal': {
      width: 'var(--modal-xxlg-w)',

      '& .modalBody': {
        backgroundColor: 'var(--selection-hover)',
        height: 'var(--modal-xxlg-h)',

        '&.autoHeight': {
          maxHeight: 'var(--modal-xxlg-h)',
        },
      },
    },
  },

  side: {
    position: 'fixed',
    right: 0,
    top: 0,
    height: '100%',

    'body:has(#playBarLayout) &': {
      '& .rc-dialog-body': {
        paddingBottom: 'var(--song-player-h)',
      },
    },

    '&, & .rc-dialog-content': {
      borderRadius: 0,
    },

    '& .rc-dialog-content': {
      height: '100vh',
      backgroundColor: 'var(--primaryLightyToBalticSeaDark)',
      display: 'grid',
      gridTemplateRows: 'auto 1fr',
    },

    '& .rc-dialog-header': {
      borderRadius: 0,
      color: 'var(--text-primary)',
      backgroundColor: 'var(--background-paper)',
      padding: '0 28px',
      height: '62px',

      '& .rc-dialog-title': {
        fontWeight: 500,
        fontSize: '21px',
        lineHeight: '24px',

        '@media screen and (min-width: 1441px)': {
          fontSize: '24px',
          lineHeight: '26px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        padding: '0 36px',
        height: '84px',
      },
    },

    '& .rc-dialog-close': {
      color: 'var(--text-primary)',
      borderRadius: '4px',
      border: '1px solid var(--text-primary)',
      display: 'grid',
      placeItems: 'center',
      width: '30px',
      height: '30px',
      right: '28px',
      top: '16px',

      '@media screen and (min-width: 1441px)': {
        width: '36px',
        height: '36px',
        right: '36px',
        top: '24px',
      },
    },

    '& .rc-dialog-body': {
      zIndex: 0,

      '& .viboButton.defaultDisplay': {
        color: 'var(--primary-main)',
      },

      '&:has(:is(& > .modalFooter, & > .modalHeader, & > .headers)), & > .formWithFormik, & .viboWizard .step': {
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto',
        gridTemplateColumns: '100%',
      },

      '&:has(.modalHeader)': {
        '& > .formWithFormik, & .viboWizard .step': {
          gridTemplateRows: 'auto 1fr auto',
          gridTemplateColumns: '100%',
        },
      },

      '& > .formWithFormik': {
        maxHeight: '100%',
        height: '100%',
      },

      '& > .viboWizard': {
        gridRow: 2,
      },

      '& .headers': {
        display: 'grid',
        gridRow: 1,
      },

      '& .modalBody': {
        height: '100%',
        minHeight: 0,
        padding: '0 28px',
        fontSize: '14px',

        '& .modalBodyScroll': {
          marginTop: 0,
          marginBottom: 0,
          paddingTop: '16px',
          paddingBottom: '16px',

          '&:has(> .viboWizard)': {
            display: 'grid',
          },

          '&:has(.emptyState), &:has(.lottieBox)': {
            display: 'flex',
            flexDirection: 'column',

            '& .emptyState, & > .lottieBox, & .step > .lottieBox': {
              transform: 'translateY(-40%)',
              margin: 'auto 0',
              gridRow: 2,
            },
          },

          '& > .contentArea': {
            display: 'grid',
            padding: '12px',

            '&:not(.gap-sm)': {
              gap: '20px',

              '@media screen and (min-width: 1441px)': {
                gap: '24px',
              },
            },

            '&.gap-sm': {
              gap: '12px',

              '@media screen and (min-width: 1441px)': {
                gap: '16px',
              },
            },

            '@media screen and (min-width: 1441px)': {
              padding: '16px',
            },
          },

          '@media screen and (min-width: 1441px)': {
            paddingTop: '24px',
            paddingBottom: '24px',
          },
        },

        '@media screen and (min-width: 1441px)': {
          padding: '0 36px',
          fontSize: '16px',
        },
      },

      '& .modalHeader': {
        gap: '6px',
        padding: '8px 28px',

        '& > .searchInputWrapper': {
          width: '100%',
        },

        '& > .viboMenu': {
          position: 'absolute',
          display: 'flex',
        },

        '@media screen and (min-width: 1441px)': {
          gap: '8px',
          padding: '12px 36px',
        },
      },
    },

    '& .modalFooter': {
      borderTop: '1px solid var(--primary-light)',
      padding: '12px',

      '@media screen and (min-width: 1441px)': {
        padding: '16px',
      },
    },

    '&.smModal': {
      width: 'var(--modal-side-sm-w)',
    },

    '&.mdModal': {
      width: 'var(--modal-side-md-w)',
    },
  },
  // ___________________________________

  // ----------------------------------
  // Modal wrapper
  // ----------------------------------
  viboModalWrap: {
    display: 'grid',
  },

  defaultViboModalWrap: {
    placeItems: 'center',
  },

  sideViboModalWrap: {},
  // ___________________________________

  modalHeader: {
    padding: '6px 16px',
    backgroundColor: 'var(--background-paper)',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 2,

    '&:first-child': {
      gridRow: 1,
    },

    '& > .clickAwayListener': {
      width: '100%',
    },

    '@media screen and (min-width: 1441px)': {
      minHeight: '60px',
    },
  },

  modalBody: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    padding: '0',
    zIndex: 1,
    gridRow: 2,

    '&.noScroll': {
      padding: '16px',
    },
  },

  modalFooter: {
    display: 'flex',
    alignItems: 'center',
    zIndex: 0,
    gridRow: 3,
    backgroundColor: 'var(--background-paper)',

    '& .viboButton': {
      width: '50%',
      justifyContent: 'center',

      '&:not(:last-child)': {
        margin: '0 16px 0 0',
      },

      '&:only-child': {
        minWidth: '100%',
      },
    },
  },

  modalMask: {
    backgroundColor: 'var(--modal-mask)',
  },
}));

export default useStyles;
